import React from "react";
import {Button, Col, Row} from "antd";
import {Link} from "react-router-dom";

const SliderItem = ({slide}) => {
    return (
        <div className="h-420">
            <Row>
                <Col md={12} lg={12}>
                    <img src={slide.bg} alt="" className="w-full h-full rounded-l-xl" />
                </Col>
                <Col md={12} lg={12}>
                    <div className="bg-white rounded-r-xl h-full flex flex-col justify-between py-8 px-9">
                        <div>
                            <h2 className="text-3xl">{slide.title} Metahut</h2>
                            <p className="text-lg">Owner <Link to="/" className="text-pink-400 font-bold">{slide.nickname}</Link></p>
                        </div>
                        <div className="flex items-center justify-between flex-wrap gap-x-2">
                            <div className="flex items-center gap-x-2">
                                <i className="icon-pin text-xl text-pink-400"></i>
                                <span className="text-xl">Metafluence City, {slide.plotID}</span>
                            </div>
                            <Button type="primary" className="flex items-center gap-x-2 bg-pink-400 rounded-xl border-0 uppercase">
                                <span className="text-xl">Jump in</span>
                                <i className="icon-right-circle text-lg text-white"></i>
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default SliderItem;